import i18next from 'i18next'
import { List } from 'immutable'
import * as React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type TooltipProps = {
  id: string
  placement?: 'top' | 'right' | 'bottom' | 'left'
  children: React.ReactNode
  tooltipCopy: string
}

export const TooltipLayout = (p: TooltipProps) => {
  return (
    <OverlayTrigger
      placement={p.placement || 'top'}
      overlay={
        <Tooltip id={`tooltip-${p.id}`}>
          {p.tooltipCopy}
        </Tooltip>
      }
    >
      <button type="button" className={`button--tooltip button--tooltip-${p.placement || 'top'}`}>
        <span className="sr-text">{p.tooltipCopy}</span>
        {p.children}
      </button>
    </OverlayTrigger>
  )
}
